import { isServer } from "solid-js/web";
import { useWire } from "~/wire";

export const gateCreditsDescriptions = {
  prompt: "Create an account to keep using Storytell.",
  fileUpload: "Please top up your credits to upload more files",
};

export const useGateActionByCredits = <T extends Array<unknown>, U>(
  description: () => string,
  action: (...args: T) => U,
  onCancel?: () => void,
) => {
  const wire = useWire();

  const wrappedAction = (...args: T): U | undefined => {
    const credits = wire.billing.credits();
    if (credits <= 0 && wire.billing.show()) {
      wire.ui.creditsGate.openModal(description());
      onCancel?.();
      return;
    }
    return action(...args);
  };

  return wrappedAction;
};
